import { useAtomValue, useSetAtom } from 'jotai'
import { ChevronRight } from 'lucide-react'
import {
  onboardingDialogAtom,
  openOnboardingDialog,
} from '@/src/stores/onboarding'
import {
  openSelectWalletsDialog,
  selectWalletsDialogAtom,
} from '@/src/stores/select-wallets'
import { userAtom } from '@/src/stores/user/atoms'
import { BottomSheetListItem } from '../ui/bottom-sheet/list'
import { Plus } from '../ui/icons/plus'
import { ListRowSide, ListRowSideName } from '../ui/list-row'

export const AddAnotherWalletListItem = () => {
  const user = useAtomValue(userAtom)
  const setSelectWalletsDialog = useSetAtom(selectWalletsDialogAtom)
  const setOnboardingDialogState = useSetAtom(onboardingDialogAtom)

  const handleOpenDialog = () => {
    if (user.id === 'guest') {
      // Encourage email login
      setOnboardingDialogState(openOnboardingDialog('wallets'))
    } else {
      setSelectWalletsDialog(openSelectWalletsDialog())
    }
  }

  return (
    <BottomSheetListItem onClick={handleOpenDialog} disabled={!user}>
      <div className='flex items-center justify-center size-10 rounded-lg bg-button-secondary shrink-0'>
        <Plus className='text-button-secondary-text group-hover:text-button-secondary-text-hover size-6' />
      </div>
      <ListRowSide containerClassName='flex-1 min-w-0' className='gap-0'>
        <ListRowSideName className='text-base'>
          Add another wallet
        </ListRowSideName>
      </ListRowSide>
      <ListRowSide
        className='text-right gap-0'
        showIndicator
        customIndicator={
          <ChevronRight className='text-tertiary size-6' size={24} />
        }
      />
    </BottomSheetListItem>
  )
}
